import { WORKSPACE_IDS } from '@/configs/workspace-ids';

export const CONTACTS_MENU_WORKSPACE_IDS = new Set<string>([
  WORKSPACE_IDS.HEY_REACH,
  WORKSPACE_IDS.PAPAYA,
  WORKSPACE_IDS.BOUNDLESS,
]);

export const canShowContactsMenu = (workspaceId?: string | null): boolean =>
  CONTACTS_MENU_WORKSPACE_IDS.has(workspaceId ?? '');
